import { useI18n } from '@/i18n';

interface ErrorMessageProps {
  title?: string;
  message: string;
}

export function ErrorMessage({ title, message }: ErrorMessageProps) {
  const { t } = useI18n();
  return (
    <div className="error-banner glass-panel" role="alert">
      <p className="error-banner__title">{title ?? t('common.error')}</p>
      <p className="error-banner__message">{message}</p>
    </div>
  );
}
